/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BoardMember_user = {
    readonly id: string;
    readonly photo: string | null;
    readonly fullName: string | null;
    readonly role: string | null;
    readonly email: string;
    readonly linkedin: string | null;
    readonly " $refType": "BoardMember_user";
};
export type BoardMember_user$data = BoardMember_user;
export type BoardMember_user$key = {
    readonly " $data"?: BoardMember_user$data;
    readonly " $fragmentRefs": FragmentRefs<"BoardMember_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BoardMember_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "height",
          "value": 250
        },
        {
          "kind": "Literal",
          "name": "width",
          "value": 250
        }
      ],
      "kind": "ScalarField",
      "name": "photo",
      "storageKey": "photo(height:250,width:250)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkedin",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '5fa85b54f2da3e83ea0ad4fe4e69bf79';
export default node;
